angular.module('Const').constant('trackingStatusesConst', {
    'trackingStatuses': {
        'documentationprepared': 'Documentation Prepared',
        'bookingarranged': 'Booking Arranged',
        'collected': 'Collected',
        'intransit': 'In Transit',
        'cancelled': 'Cancelled',
        'missing': 'Missing',
        'customs_held': 'Customs Held',
        'damaged': 'Damaged',
        'arrivedatdestination': 'Arrived at Destination',
        'outfordelivery': 'Out for Delivery',
        'attempted_delivery': 'Attempted Delivery',
        'awaiting_collection': 'Awaiting Collection',
        'delivered': 'Delivered',
        'return_to_sender':'Return to Sender',
        'instore': 'In Store'
    }
});



// WEBPACK FOOTER //
// ./js/consts/trackingStatuses.js